import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { SectionHeading } from '../components/ui/SectionHeading';
import { motion } from 'framer-motion';
import { Users, Award, Heart, Mountain } from 'lucide-react';
const teamMembers = [{
  name: 'Pemba Sherpa',
  role: 'Lead Guide & Operations Director',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=1974&auto=format&fit=crop',
  experience: '15+ years',
  specialty: 'Everest Region Expert'
}, {
  name: 'Sarah Mitchell',
  role: 'International Relations Manager',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1974&auto=format&fit=crop',
  experience: '8 years',
  specialty: 'Client Experience'
}, {
  name: 'Ang Dorje Sherpa',
  role: 'Senior Trekking Guide',
  image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=1974&auto=format&fit=crop',
  experience: '12 years',
  specialty: 'Annapurna Circuit'
}, {
  name: 'Maya Gurung',
  role: 'Cultural Experience Coordinator',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=2070&auto=format&fit=crop',
  experience: '6 years',
  specialty: 'Cultural Tours'
}, {
  name: 'Tenzing Norgay',
  role: 'High Altitude Specialist',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=1974&auto=format&fit=crop',
  experience: '10 years',
  specialty: 'Technical Climbs'
}, {
  name: 'Lakpa Sherpa',
  role: 'Logistics & Safety Manager',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=2070&auto=format&fit=crop',
  experience: '14 years',
  specialty: 'Safety Protocols'
}];
const stats = [{
  icon: Users,
  value: '50+',
  label: 'Expert Team Members'
}, {
  icon: Award,
  value: '200+',
  label: 'Years Combined Experience'
}, {
  icon: Heart,
  value: '10,000+',
  label: 'Happy Clients'
}, {
  icon: Mountain,
  value: '100%',
  label: 'Success Rate'
}];
export function OurTeamPage() {
  return <div className="min-h-screen bg-white font-sans" data-id="element-1636">
      <Navbar data-id="element-1637" />

      {/* Hero Section */}
      <div className="relative h-[60vh] min-h-[500px] flex items-center justify-center" data-id="element-1638">
        <div className="absolute inset-0 bg-cover bg-center z-0" style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=2070&auto=format&fit=crop")'
      }} data-id="element-1639">
          <div className="absolute inset-0 bg-gradient-to-b from-blue-900/70 via-blue-900/50 to-blue-900/80" data-id="element-1640" />
        </div>
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto" data-id="element-1641">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="flex justify-center mb-6" data-id="element-1642">
            <div className="w-16 h-16 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center" data-id="element-1643">
              <Users className="text-white" size={32} data-id="element-1644" />
            </div>
          </motion.div>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-5xl md:text-6xl font-bold mb-6 tracking-tight" data-id="element-1645">
            Meet Our Team
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="text-xl md:text-2xl text-blue-100 font-light max-w-2xl mx-auto" data-id="element-1646">
            Passionate experts dedicated to making your Himalayan adventure
            unforgettable
          </motion.p>
        </div>
      </div>

      {/* Stats Section */}
      <section className="py-16 px-4 bg-gradient-to-r from-blue-600 to-cyan-600" data-id="element-1647">
        <div className="max-w-7xl mx-auto" data-id="element-1648">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-1649">
            {stats.map((stat, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="text-center text-white" data-id="element-1650">
                <div className="flex justify-center mb-4" data-id="element-1651">
                  <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center" data-id="element-1652">
                    <stat.icon size={32} data-id="element-1653" />
                  </div>
                </div>
                <p className="text-4xl font-bold mb-2" data-id="element-1654">{stat.value}</p>
                <p className="text-blue-100 text-sm" data-id="element-1655">{stat.label}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Overview Section */}
      <section className="py-20 px-4 max-w-4xl mx-auto" data-id="element-1656">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-1657">
          <SectionHeading title="Who We Are" subtitle="Overview" data-id="element-1658" />
          <div className="prose prose-lg max-w-none text-stone-700 leading-relaxed space-y-4" data-id="element-1659">
            <p data-id="element-1660">
              Our team is the heart and soul of Himalayan Trekking. Comprised of
              experienced local guides, international coordinators, and
              passionate adventure specialists, we bring together decades of
              combined expertise in high-altitude trekking, cultural tourism,
              and expedition management.
            </p>
            <p data-id="element-1661">
              Every member of our team shares a deep love for the Himalayas and
              a commitment to providing safe, authentic, and transformative
              experiences. Our guides are not just experts in navigation and
              mountain safety—they're storytellers, cultural ambassadors, and
              friends who will enrich your journey with their knowledge and
              warmth.
            </p>
            <p data-id="element-1662">
              We believe in sustainable tourism that benefits local communities,
              preserves the environment, and creates meaningful connections
              between travelers and the incredible people of Nepal. When you
              trek with us, you're not just a client—you're part of our extended
              family.
            </p>
          </div>
        </motion.div>
      </section>

      {/* Team Grid */}
      <section className="bg-stone-50 py-20 px-4" data-id="element-1663">
        <div className="max-w-7xl mx-auto" data-id="element-1664">
          <SectionHeading title="Our Expert Team" subtitle="The people who make it happen" data-id="element-1665" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1666">
            {teamMembers.map((member, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300" data-id="element-1667">
                <div className="relative h-80 overflow-hidden" data-id="element-1668">
                  <img src={member.image} alt={member.name} className="w-full h-full object-cover" data-id="element-1669" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" data-id="element-1670" />
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white" data-id="element-1671">
                    <h3 className="text-2xl font-bold mb-1" data-id="element-1672">{member.name}</h3>
                    <p className="text-blue-200 text-sm" data-id="element-1673">{member.role}</p>
                  </div>
                </div>
                <div className="p-6" data-id="element-1674">
                  <div className="flex items-center justify-between mb-3" data-id="element-1675">
                    <div data-id="element-1676">
                      <p className="text-xs text-stone-500 uppercase tracking-wide mb-1" data-id="element-1677">
                        Experience
                      </p>
                      <p className="text-stone-900 font-semibold" data-id="element-1678">
                        {member.experience}
                      </p>
                    </div>
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-1679">
                      <Award className="text-blue-600" size={24} data-id="element-1680" />
                    </div>
                  </div>
                  <div data-id="element-1681">
                    <p className="text-xs text-stone-500 uppercase tracking-wide mb-1" data-id="element-1682">
                      Specialty
                    </p>
                    <p className="text-stone-900 font-semibold" data-id="element-1683">
                      {member.specialty}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Join Our Team CTA */}
      <section className="py-20 px-4 bg-gradient-to-br from-blue-900 to-cyan-900 text-white" data-id="element-1684">
        <div className="max-w-4xl mx-auto text-center" data-id="element-1685">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-1686">
            <Mountain size={48} className="mx-auto mb-6 text-cyan-400" data-id="element-1687" />
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1688">
              Want to Join Our Team?
            </h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-1689">
              We're always looking for passionate, experienced guides and
              coordinators who share our values
            </p>
            <a href="#contact" data-id="element-1690">
              <button className="bg-white text-blue-900 px-8 py-4 rounded-full font-semibold hover:bg-blue-50 transition-colors" data-id="element-1691">
                Get in Touch
              </button>
            </a>
          </motion.div>
        </div>
      </section>

      <Footer data-id="element-1692" />
    </div>;
}